// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

const updateHasSearchResults = () => true;

export default (state = false, action) => {

    const actionTypes = {
        [actions.UPDATE_HAS_SEARCH_RESULTS]: updateHasSearchResults
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/shared/reducers/has-search-results.js